import axios from 'axios';
import URLs from '@/config/constants';

// eslint-disable-next-line import/prefer-default-export
export const verifyBeneficiary = async ({ rut, dv, token }) => {
  const headers = {
    'Content-Type': 'application/json; charset=UTF-8',
    Authorization: token,
  };
  return axios.create({
    baseURL: URLs.GetVerifyBeneficiary,
    headers,
    timeout: 60000,
  }).post('', { rut, dv }).then((resp) => {
    if (resp.status === 200) { return Promise.resolve(resp); }
    const responde = { response: { status: resp.status } };
    return Promise.reject(responde);
  }).catch((resp) => {
    const responde = { response: { status: resp.response.status, data: resp.response.data } };
    return Promise.reject(responde);
  });
};

const headers = {
  'Content-Type': 'application/json; charset=UTF-8',
  Authorization: process.env.VUE_APP_TOKEN_TEMP,
};
export const getVerifyBeneficiarySendEmail = async payload => axios.create({
  baseURL: URLs.GetVerifyBeneficiaryEmail,
  headers,
  timeout: 60000,
}).post('', payload).then((resp) => {
  if (resp.status === 200) { return Promise.resolve(resp); }
  const responde = { response: { status: resp.status } };
  return Promise.reject(responde);
}).catch((resp) => {
  const responde = { response: { status: resp.response.status } };
  return Promise.reject(responde);
});
